import { gql, useQuery } from "@apollo/client";

export type ImageType = {
  id: number;
  name: string;
  preview: string;
  previewFull: string;
  resolution: number;
  format: string;
  isNew: boolean;
  year?: number;
  bought: boolean;
  price: number
  sizes: {
    widthSM:number
    heightSM:number
  }
};

export const ImageFragment = gql`
  fragment ImageFragment on ShopItem {
    id
    name
    preview
    previewFull
    resolution
    isNew
    year
    bought
    price
    format
    sizes {
      widthSM
      heightSM
    }
  }
`;

const IMAGES_QUERY = gql`
  query images($ids: [Int]) {
    images(ids: $ids, first: 100, after: 0) {
      items {
        ...ImageFragment
      }
    }
  }
  ${ImageFragment}
`;

const useImages = (
  imageIds: number[]
): { loading: boolean; error: Error | undefined; images: ImageType[] } => {
  const { data, loading, error } = useQuery<{
    images: { items: ImageType[] };
  }>(IMAGES_QUERY, {
    variables: {
      ids: imageIds,
    },
    skip: imageIds.length === 0,
  });
  console.log(data?.images)

  return {
    loading,
    error,
    images: data && data.images ? data.images.items : [],
  };
};

export default useImages;
